import { render, staticRenderFns } from "./Frequency.vue?vue&type=template&id=8a58c26c&scoped=true&"
import script from "./Frequency.vue?vue&type=script&lang=js&"
export * from "./Frequency.vue?vue&type=script&lang=js&"
import style0 from "./Frequency.vue?vue&type=style&index=0&id=8a58c26c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a58c26c",
  null
  
)

export default component.exports